// <copyright file="window-token.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 12/31/2025 by Sumanth Satheesh
// </copyright>

import { DOCUMENT } from "@angular/common";
import { inject, InjectionToken } from "@angular/core";

// Defines WINDOW.
export const WINDOW = new InjectionToken<Window>("WindowToken", {
  factory: () => {
    const { defaultView } = inject(DOCUMENT);
    if (!defaultView) {
      throw new Error("Window is not available");
    }
    return defaultView;
  }
});
